import '../../Assets/Styles/home.css';
import '../../Assets/Styles/partner.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 
import HeaderView from '../../Components/Layout/Header';


const PartnerRegisterConfirm = (props) => {
    
// Set var from props
const { 
    stepIndex, 
    stepData, 
    stepDataAll, 
    stepValidations 
  } = props;

  // console.log('<<<<<<<<<<<<<<<<< stepDataAll STEP 7 >>>>>>>>>>>>>>>>>>>> '+JSON.stringify(stepDataAll,null,2));

  const creditCardLater = stepDataAll[4].creditCardLater;
  const sendDocumentsLater = stepDataAll[1].sendDocumentsLater; 

  const [showMessage, setShowMessage] = React.useState(false);

// set Use of history for PUSH 
var navigate = useNavigate();
    
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

// Run after mount component
React.useEffect(() => {
       
  // set scroll to top
  window.scrollTo(0, 1);
      
  // Runs when UNMOUNT component
  return () => {
    
    // unmount...	
    
  };
  
}, []); 


// If not logged, show login screen
  return (
    <>
    <div style={{ width: '100%'}}>

        {/*<!-- Blog Highlights BOX -->*/}
        <div className="wrapper_partner__content_container" style={{paddingTop:"calc(0.5rem + 70px)"}}> 
        
            {/*<!-- Blog Highlight with 4 cards -->*/}
            <div className="wrapper_partner__content_container_block">  

                <div className="wrapper_partner__content_container_highlight" style={{marginTop:"1.5rem",width:"unset",alignItems:"flex-start"}}>

                        <div className="wrapper_partner__content_container_highlight_title" style={{fontSize:"2.25rem",textAlign:"left"}}>{(!creditCardLater && !sendDocumentsLater) ? "Cadastro finalizado com sucesso!" : "Cadastro finalizado com pendências"}</div>

                        {(!sendDocumentsLater && !creditCardLater) &&
                            (<div className="wrapper_partner__content_container_highlight_description tAlignL">
                                
                                <p>Parabéns! Seu cadastro foi finalizado com sucesso e já está ativo para receber direcionamentos.</p>
                                
                                <p>A equipe da Estação do Olho fará uma análise detalhada das informações e documentos enviados. Caso alguma inconsistência seja identificada, seu cadastro poderá ser colocado em análise temporária, com notificação via e-mail. Enquanto isso, você já pode começar a receber direcionamentos normalmente.</p>                                
                                
                            </div>)
                        }   

                        {(sendDocumentsLater || creditCardLater) && (
                          <div className="wrapper_partner__content_container_highlight_description tAlignL">
                            <p style={{ marginBottom: "1.5rem" }}>
                              Seu cadastro foi enviado com sucesso. Confira abaixo as pendências:
                            </p>

                            {sendDocumentsLater && !creditCardLater && (
                              <>
                              <p>
                                📄 <strong>Documentos não enviados</strong>: você optou por enviar os documentos mais tarde. 
                                Isso não impede o recebimento de direcionamentos imediatamente, mas seu cadastro poderá entrar em análise a qualquer momento.
                              </p>
                              <p style={{ marginTop: "1.5rem" }}>
                                Você pode adicionar documentos comprobatórios a qualquer momento acessando sua área administrativa. Não postergue a adição dos documentos para evitar o bloqueio temporário de seu cadastro.
                              </p>
                              </>
                            )}

                            {creditCardLater && !sendDocumentsLater && (
                              <>
                                <p>
                                  💳 <strong>Cartão de crédito não informado</strong>: é necessário informar um cartão válido para liberar o recebimento de direcionamentos.
                                </p>
                                <p style={{ marginTop: "1.5rem" }}>
                                  Você pode adicionar um cartão de crédito a qualquer momento acessando sua área administrativa. Assim que os dados forem inseridos e validados, sua conta será ativada para recebimento de direcionamentos.
                                </p>
                              </>
                            )}

                            {creditCardLater && sendDocumentsLater && (
                              <>
                                <p>
                                  📄 <strong>Documentos não enviados</strong>: você optou por enviar os documentos mais tarde. 
                                  Isso não impede o recebimento de direcionamentos imediatamente, mas seu cadastro poderá entrar em análise.
                                </p>
                                <p>
                                  💳 <strong>Cartão de crédito não informado</strong>: é necessário informar um cartão válido para liberar o recebimento de direcionamentos.
                                </p>

                                <p style={{ marginTop: "1.5rem" }}>
                                  Você pode adicionar documentos comprobatórios e um cartão de crédito a qualquer momento acessando sua área administrativa.  Não postergue a adição dos documentos para evitar o bloqueio temporário de seu cadastro. Assim que os dados de cartão de crédito forem inseridos e validados, sua conta será ativada para recebimento de direcionamentos.
                                </p>

                              </>
                            )}

                          </div>
                        )}

                </div>

                <div className="wrapper_partner__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem",justifyContent:"flex-start"}}><Button label="Ir para área do parceiro" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem",marginLeft:"unset"}} onClick={()=>window.location.href = 'https://parceiros.estacaodoolho.com.br'}  /></div>

            </div>	
        
        </div>
     

    </div>
    </>
  );
    
}

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
  servicesList: state.partnerReducer.servicesList,
  specialitiesList: state.partnerReducer.specialitiesList,  
});

const mapDispatchToProps = {
  ...AppActions
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerRegisterConfirm);

